// [Basis chrome] El footer del explorador es el de la landing. Este es el unico
// importador de ui/snippets/footer/Footer en todo el arbol, asi que esta linea
// cambia el footer de las cuatro superficies que lo pintan a la vez.
import Footer from 'ui/snippets/basis/BasisFooter';

import Container from './Container';
import Content from './Content';
import MainArea from './MainArea';
import MainColumn from './MainColumn';
import NavBar from './NavBar';
import Root from './Root';
import SideBar from './SideBar';

// [Basis chrome] La barra superior de Blockscout (precio, gas, ajustes, menu de
// redes) desaparece: la navbar de la landing tiene que ser el primer elemento de
// la pagina, y no puede serlo con una franja encima.
//
// No se pierde nada en este despliegue: TopBarStats se queda vacio sin servicio
// de stats (NEXT_PUBLIC_STATS_API_HOST=), NetworkMenu exige featuredNetworks, que
// no esta configurado, y el engranaje de ajustes -- el unico control real que
// quedaba ahi -- se ha movido al cluster derecho de la navbar.
//
// Se conserva el nombre TopRow, y no se borra de los cinco Layouts que lo
// renderizan, para que el diff sea este fichero y no cinco.
const TopRow = () => null;

export {
  Root,
  Container,
  Content,
  MainArea,
  SideBar,
  NavBar,
  MainColumn,
  Footer,
  TopRow,
};

// Root
//  Container
//    TopRow            <- vacio (Basis chrome)
//    NavBar            <- BasisNavBar, la navbar de la landing
//    MainArea
//       SideBar        <- vacio con NEXT_PUBLIC_NAVIGATION_LAYOUT=horizontal
//       MainColumn
//          Content
//    Footer            <- BasisFooter, el footer de la landing
